import { render, staticRenderFns } from "./AddSale.vue?vue&type=template&id=35563603&scoped=true&"
import script from "./AddSale.vue?vue&type=script&lang=js&"
export * from "./AddSale.vue?vue&type=script&lang=js&"
import style0 from "./AddSale.vue?vue&type=style&index=0&id=35563603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35563603",
  null
  
)

export default component.exports